import { lazy } from 'react';

import type { TRateRouter } from '@features/Rate/types/RateRouter';
import type { RouteConfig } from '@/router/route.types';
import type { TPage } from '@/router/type';

import { composeRootPath } from '@/router/utils';

const PAGES: Record<TRateRouter, TPage> = {
  GET_RATE: {
    id: 'get-rate',
    name: 'Service Rate Request',
    path: composeRootPath('/get-rate'),
  },
};

const ROUTES: Record<TRateRouter, RouteConfig> = {
  GET_RATE: {
    id: PAGES.GET_RATE.id,
    name: PAGES.GET_RATE.name,
    path: PAGES.GET_RATE.path,
    component: lazy(() => import('@features/Rate/pages/RateRequest.page')),
  },
};

export default {
  PAGES,
  ROUTES,
};
